import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const dbgOn = () => typeof window !== 'undefined' && localStorage.getItem('debug:notifications') === '1';
const log = (...a) => { if (dbgOn()) console.log('[NotifStore]', ...a); };

const byDate = (a, b) =>
    new Date(b.createdAt || b.timestamp) - new Date(a.createdAt || a.timestamp);

const sortUnreadFirst = (arr) =>
    [...arr].sort((a, b) => {
        const aUnread = !a.readAt;
        const bUnread = !b.readAt;
        if (aUnread !== bUnread) return aUnread ? -1 : 1;
        return byDate(a, b);
    });

const idOf = (n) => n?._id || n?.meta?.syncId;

const useNotifications = create(
    persist(
        (set, get) => ({
            items: [],

            setAll: (arr = []) => set(() => {
                log('setAll', { count: arr?.length || 0 });
                return { items: sortUnreadFirst(arr) };
            }),

            push: (n) => set((state) => {
                const id = idOf(n);
                if (!id) {
                    log('push(no-id)', { title: n?.title });
                    return { items: sortUnreadFirst([n, ...state.items]) };
                }
                const idx = state.items.findIndex((x) => idOf(x) === id);
                let next;
                if (idx >= 0) {
                    const current = state.items[idx];
                    const merged = { ...current, ...n, readAt: current.readAt || n.readAt || null };
                    next = [...state.items];
                    next[idx] = merged;
                    log('push(merge)', { id, readAt: merged.readAt });
                } else {
                    next = [n, ...state.items];
                    log('push(add)', { id, unreadBefore: state.items.filter(i => !i.readAt).length });
                }
                return { items: sortUnreadFirst(next) };
            }),

            markRead: (id) => set((state) => {
                const now = new Date().toISOString();
                const beforeUnread = state.items.filter((x) => !x.readAt).length;
                const next = state.items.map((x) =>
                    idOf(x) === id && !x.readAt ? { ...x, readAt: now } : x
                );
                const afterUnread = next.filter((x) => !x.readAt).length;
                log('markRead', { id, beforeUnread, afterUnread });
                return { items: sortUnreadFirst(next) };
            }),

            markAllRead: () => set((state) => {
                const now = new Date().toISOString();
                const beforeUnread = state.items.filter((x) => !x.readAt).length;
                const next = state.items.map((x) => (x.readAt ? x : { ...x, readAt: now }));
                log('markAllRead', { beforeUnread, afterUnread: 0 });
                return { items: sortUnreadFirst(next) };
            }),

            clear: () => {
                log('clear');
                set({ items: [] });
            },
        }),
        { name: 'notifications' }
    )
);

export default useNotifications;
